import './App.css'
import Navbar from "./Layout/Navbar";
import Footer from "./Layout/Footer";
import About from "./Screens/About";
import Contact from "./Screens/Contact";
import Home from "./Screens/Home";
import Project from "./Screens/Project";
import Skills from "./Screens/Skills";
import AnimatedCursor from './Hooks/AnimatedCursor';
import { useEffect, useState } from 'react';
import Loader from './Components/Loader';
import useTheme from './Hooks/useTheme';

const THEME_CURSOR = {
  light:  '234, 88, 12',
  dark:   '234, 88, 12',
  ocean:  '56, 189, 248',
  forest: '34, 197, 94',
  rose:   '244, 63, 94',
  purple: '168, 85, 247',
};

function App() {
  const [load, updateLoad] = useState(true);
  const [theme] = useTheme();
  const cursorColor = THEME_CURSOR[theme] || THEME_CURSOR.light;

  useEffect(() => {
    const timer = setTimeout(() => updateLoad(false), 1300);
    return () => clearTimeout(timer);
  }, []);

  console.log(
    '%c Oh, you found the console! Feeling adventurous, huh? 🕵️♂️',
    'background: #ff5252; color: #fff; padding: 10px; font-size: 16px; font-weight: bold;'
  );

  return (
    <>
      <Loader load={load} />
      <div style={{ backgroundColor: 'var(--bg)', color: 'var(--text)', minHeight: '100vh', transition: 'background-color 0.3s ease, color 0.3s ease' }}>
        <Navbar />
        <AnimatedCursor
          key={theme}
          innerSize={15}
          outerSize={15}
          color={cursorColor}
          outerAlpha={0.4}
          innerScale={0.7}
          outerScale={5}
          clickables={['h1', 'h2', 'span', 'p', '.link', 'a']}
        />
        <Home />
        <Project />
        <Skills />
        <About />
        <Contact />
        <Footer />
      </div>
    </>
  );
}

export default App;
